export default __webpack_public_path__ + "static/media/2026_banner_4.fd2af135.png";